import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import NextBtn from './next';
import { jumpTo } from '@/utils';

const Page6 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleDetail = () => {
    jumpTo(`storm://app/stock/detail?stockcode=${data.highestUserStock.stockCode}`)
  }

  return (
    <Container className="page page2" ref={containerRef}>
      {!!data.userStockCount && (
        <div className="data-wrap">
          <div className="user-data">2025这一年</div>
          <div className="user-data">
            你添加了<span className="light-data">{data.userStockCount}</span>只个股
          </div>
          <div className="user-data">
            超越了<span className="light-data">{data.userStockX}%</span>的风云用户
          </div>
          <div className="user-data">你自选股添加后涨幅最高是</div>
          {data.highestUserStock && (
            <div className="user-data" onClick={handleDetail}>
              <span className="light-data">{data.highestUserStock.stockName}</span>，涨幅达
              <span className="light-data">{data.highestUserStockChangePct}%</span>
            </div>
          )}
          <div className="user-data">{Number(data.highestUserStockChangePct) >= 30 ? '你抓住了这只大牛股吗？' : '这只股票，你现在还看好？'}</div>
          <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
        </div>
      )}
      {!data.userStockCount && (
        <div className="data-wrap">
          <div className="user-data">2025年11月14日</div>
          <div className="user-data">
            大盘触及<span className="light-data">4034</span>点，创年内高点
          </div>
          <div className="user-data">
            朋友，你2025年跑赢了大盘吗？
          </div>
        </div>
      )}

      <div className="data-bg">
        <img
          className="logo-img"
          src="https://file.wogoo.com/image/activity/active_205/page6-bg@2x.png"
          alt=""
        />
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={(direction) => onNext(direction, 6)} />
    </Container>
  );
};

const Container = styled.div``;

export default React.memo(forwardRef(Page6));



// WEBPACK FOOTER //
// ./src/views/activity_205/page6.js